"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportcardsTypesModel = /** @class */ (function () {
    function ReportcardsTypesModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/report-card-types",
            UPDATE: APPURL + "/api/v1/report-card-types",
            CREATE: APPURL + "/api/v1/report-card-types",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ReportcardsTypesModel.prototype.extract = function (result) {
        return result.data;
    };
    ReportcardsTypesModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ReportcardsTypesModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    ReportcardsTypesModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ReportcardsTypesModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ReportcardsTypesModel.prototype.destroy = function (card) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + card.id)
            .then(this.cacheResults);
    };
    return ReportcardsTypesModel;
}());
ReportcardsTypesModel.$inject = ["$http", "APPURL"];
exports.default = ReportcardsTypesModel;
